import { useContext } from 'react';

import { MediaLibraryUserPreferencesContext } from '~modules/media-library/context/MediaLibraryUserPreferences';

export default function useMediaLibraryUserPreferences() {
  const context = useContext(MediaLibraryUserPreferencesContext);
  if (!context) {
    throw new Error(`useMediaLibraryUserPreferences must be used within a MediaLibraryUserPreferencesProvider`);
  }
  return context;
}
